export const APP_LOCAL_STORAGE_LOCALE_NAME = "droople_user_setting_locale";
export const APP_LOCAL_STORAGE_LOGIN_SCREEN_LOGO = "login_screen_logo";
